import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import {
    StateType,
    hasAccess,
    hasProjectAccess,
    hasLifecycleAccess,
} from "client/utils"
import {
    PRM_LIFECYCLE,
    StoreType,
    ProjectUserList,
    AccountUserList,
    LifecycleProps,

    LoadLifecycleById,
    LoadProjectUsers,
    LoadAccountUsers,
    IsOwnerLifecycle,

    setProjectUserList,
    setAccountUserList,
    setLifecycleEdit,
    setLifecycleReloadEdit,
    initLifecycle,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    lifecycleId = null,
}: LifecycleProps) => {
    const lifecycle = useSelector((state: StoreType) => state.lifecycle.lifecycleEdit)
    const reloadEdit = useSelector((state: StoreType) => state.lifecycle.reloadEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setLifecycleReloadEdit(false))
        setTimeout(() => {
            dispatch(setLifecycleReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        setLoadState(PENDING)

        // users for select
        const promiseArray: Promise<any>[] = []
        if (project.id) {
            promiseArray.push(
                LoadProjectUsers(project.id).then((res) => {
                    const newProjectUserList: ProjectUserList = { [project.id]: res }
                    dispatch(setProjectUserList(newProjectUserList))
                }),
            )
        } else {
            promiseArray.push(
                LoadAccountUsers(userData.accountId).then((res) => {
                    const newAccountUserList: AccountUserList = { [userData.accountId]: res }
                    dispatch(setAccountUserList(newAccountUserList))
                }),
            )
        }

        Promise.all(promiseArray).then(() => {
            if (lifecycleId === 0) {
                dispatch(setLifecycleEdit(initLifecycle))
                setLoadState(IDLE)
                reload()
            } else {
                LoadLifecycleById(lifecycleId, userData.accountId, project.id).then((res) => {
                    dispatch(setLifecycleEdit(res))
                    setLoadState(IDLE)
                    reload()
                })
            }
        })
    }, [])


    const addAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, ADD)
        : hasProjectAccess(PRM_LIFECYCLE, ADD)

    const editAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, EDIT)
        : hasProjectAccess(PRM_LIFECYCLE, EDIT)

    const lifecycleEditAccess = hasLifecycleAccess(PRM_LIFECYCLE, EDIT)


    const isOwner = IsOwnerLifecycle(project.id, lifecycle, userData)
    const allowedToEdit = editAccess || isOwner || lifecycleEditAccess

    if (lifecycleId === 0 && !addAccess) return <AccessDenied />
    if (lifecycleId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!lifecycle) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {lifecycle.id ? `${lang.editLifecycle} # ${lifecycle.id}` : lang.addLifecycle}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form lifecycle={lifecycle} />
                }
                {
                    reloadEdit
                    && <Form lifecycle={lifecycle} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
